module.exports = __webpack_public_path__ + "static/nordic_6-7e715ba52552880e3ccd20d0175d1739.jpg";